module.exports = __webpack_public_path__ + "img/tsutsu.d7846e65.png";